import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import serverPostData from "../../utils/ServerPostData";
import classes from "./UserHistory.module.css";
import OHistoryCard from "../HistoryCard/OHistoryCard";
import LoadingPage from "../../pages/LoadingPage/LoadingPage";


export default function UserOHistory(props) {
  const [tg, i18n] = useTranslation("global");
  const [isLoading, setIsLoading] = useState(true);
  const [loadedUsers, setLoadedUsers] = useState([]);
  const [error, setError] = useState(null);
  const formData = new FormData();

  useEffect(() => {
    formData.append("email", props.email);

    const serverResponse = serverPostData("/fetch-user-o-history", formData);

    serverResponse
      .then((response) => {
        if (response.status === 200) {
          console.log("Data: ", response.data);
          setLoadedUsers(response.data);
          setIsLoading(false);
        } else if (response.status === 404) {
          // Handle 404 error
          setIsLoading(false);
        } else {
          // Handle other errors
          setError("An error occurred while fetching data");
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setError("An error occurred while fetching data");
        setIsLoading(false);
      });
  }, [props.email]);

  return (
    <div className={classes.box}>
      {isLoading ? (
        < LoadingPage />
      ) : error ? (
        <p>{error}</p>
      ) : loadedUsers.length === 0 ? (
        <div>
        <h1>{tg("stats.titles.OHISTORY")} </h1>
        <p>{tg("stats.card.NA_O")}</p>
        </div>
      ) : (
        <div>
          <h1>{tg("stats.titles.OHISTORY")} </h1>
          {Object.entries(loadedUsers).map(([userId, historyItems]) => (
            <div key={userId}>
              {historyItems.length > 0 ? (
                historyItems.map((historyItem) => (
                  <div key={historyItem.id} style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <OHistoryCard
                      historyID={historyItem.id}
                      title={historyItem.data.title}
                      date={historyItem.data.date}
                      progress={historyItem.data.progress}
                      totalTimes={historyItem.data.totalTimes}
                      pointValue={historyItem.data.pointValue}
                    />
                  </div>
                ))
              ) : (
                null // Don't render anything when there are no history items
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
